exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".style-module_grid_25R6fYBJl1ioCEReJNVhC7 {\n  margin-left: auto;\n  margin-right: auto;\n}\n", "", {"version":3,"sources":["/root/app/src/pages/Apis/style.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;CACpB","file":"style.module.css","sourcesContent":[".grid {\n  margin-left: auto;\n  margin-right: auto;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"grid": "style-module_grid_25R6fYBJl1ioCEReJNVhC7"
};